import store from '../../store/store';
import numeral from 'numeral';
import moment from 'moment';
import { getCurrentMonthDataFromContract } from './util.js'

export function priceFormat(value) {
    return numeral(value).format("0,0.00");
}

export function volumeFormat(quantity) {
    return numeral(quantity).format("0,0");
}

export function creditDaysFormat(value) {
    switch (value){
        case 0:
            return 'Prepayment';
        case 1:
            return value + ' Day';
        case null:
            return 'N/A'
        default:
            return value + ' Days';
    }
}

export function fuelType(fuel_id){
    let fuel = ''
    const fuelsList = store._modules.root.state.fuelsType.fuels
    const { BlendedGasoilId, BlendedDieselBioId, GasoilId, DieselId } = store._modules.root.state.metadata.productConfig
    if (fuelsList){
        fuel = fuelsList.find(fuel => fuel._id == fuel_id)
        if (fuel){
            if (fuel._id === BlendedGasoilId){
                return fuelsList.find(fuel => fuel._id === GasoilId).name
            }
            else if (fuel._id === BlendedDieselBioId){
                return fuelsList.find(fuel => fuel._id === DieselId).name
            }
            else{
                return fuel.name
            }
        }
    }
    return 'N/A'
}

export function removeComma(string){
    return parseFloat(string.replace(/,/g, ''));
}

export function fuelMeasurementType(fuel_measurement_id){
    switch (fuel_measurement_id){
        case 'STANDARD':
            return 'Standard';
        case 'AMBIENT':
            return 'Ambient';
        default:
            return 'N/A';
    }
}

export function collectionDaysFormat(collectionTime){
    switch (collectionTime){
        case 0:
            return "Today Only";
        case 1:
            return "Tomorrow Only";
        case 2:
            return "Tomorrow + 1 Only";
        case 30:
            return "1 Month";
        case -1:
            return "N/A"
        case undefined:
            return "N/A"
        default:
            return collectionTime + ' Days';
    }
}

function collectionDaysFormatDates(collectionTime, date = null) {
  let timePeriod1, timePeriod2;
  switch (collectionTime) {
    case 0:
      timePeriod1 = moment(date);
      timePeriod2 = moment(date);
      break;
    case 1:
      timePeriod1 = moment(date).add(1, "days");
      timePeriod2 = moment(date).add(1, "days");
      break;
    case 2:
      timePeriod1 = moment(date).add(2, "days");
      timePeriod2 = moment(date).add(2, "days");
      break;
    case 30:
      timePeriod1 = moment(date);
      timePeriod2 = moment(date).add(30, "days");
      break;
    default:
      timePeriod1 = moment(date);
      timePeriod2 = moment(date).add(collectionTime - 1, "days");
  }
  return `${moment(timePeriod1).format("DD/MM/YYYY")} - ${moment(timePeriod2).format("DD/MM/YYYY")}`;
}

export function liftingPeriodFormat(offer, orderCreated = null) {
  if (!offer.terminal_id) {
    return "N/A";
  }
  if (offer.liftingPeriod && offer.liftingPeriod.length === 2) {
    return `${moment(offer.liftingPeriod[0]).format("DD/MM/YYYY")} - ${moment(offer.liftingPeriod[1]).format(
      "DD/MM/YYYY"
    )}`;
  }
  return collectionDaysFormatDates(offer.collectionTime, orderCreated);
}

export function currentMonthMaximumAvailable(frequencyQuantity){
    const month = getCurrentMonthDataFromContract(frequencyQuantity)
    if(month) 
        return __formatNumbersByComma(month.maximumAvailable);
    return __formatNumbersByComma(frequencyQuantity[0].maximumAvailable);
}

export function currentMonthTotal(frequencyQuantity){
    const month = getCurrentMonthDataFromContract(frequencyQuantity)
    if(month) 
        return __formatNumbersByComma(month.quantity);
    return __formatNumbersByComma(frequencyQuantity[0].quantity);
}

export function formatNumber(number){
    return __formatNumbersByComma(number);
}

function __formatNumbersByComma(number){
    const nf = new Intl.NumberFormat();
    const newNumber = nf.format(number);
    return newNumber;
}

export function pricingMethod(type_id){
    const offerType = store._modules.root.state.sellerTabs.tabSelected.type
    switch (type_id){
        case "D1":
            return "D1";
        case "D2":
            return "D2";
        case "TRACKING":
            if(offerType === "Contracts"){
                return "Live Trigger";
            }else{
                return "Live";
            }      
        case "FIXED":
            return "Fixed";
        default:
            return "N/A";
    }
}

export function storageType(storage_type_id){
    switch (storage_type_id){
        case 'SPOT':
            return "Spot";
        case 'BUNKERING':
            return "Bunkering";
        default:
            return "N/A";
    }
}

export function offerType(isContract){
    switch (isContract){
        case true:
            return 'Contract';
        case false:
            return 'Spot';
        default:
            return 'zzzzzz';
    }
}

export function standardDateFormat(date){
    return moment(date).format('DD/MM/YYYY HH:mm')
}

export function dateFormat(date){
    return moment(date).format('DD/MM/YYYY');
}

export function yearMonthDayDateFormat(date){
    return moment(date).format('YYYY-MM-DD');
}